
import React, { useState } from 'react';
import { Button, Drawer, Space } from 'antd';
import { FaBars } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Mininav = () => {
    const [open, setOpen] = useState(false);
    const [placement, setPlacement] = useState('left');

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const handleLinkClick = () => {
        onClose();
        window.scrollTo({ top: 0, behavior: 'smooth' }); 
    };

    return (
        <>
            <Space>
                <Button type="primary" onClick={showDrawer} style={{boxShadow:'none',
                    background:'none',
                    border:'none'
                }}>
                    <FaBars />
                </Button>
            </Space>
            <Drawer
                title="Vibha Design"
                placement={placement}
                width={500}
                onClose={onClose}
                open={open}
                // extra={
                //     <Space>
                //         <Button onClick={onClose}>Cancel</Button>
                //     </Space>
                // }
            >
                <ul className="middle-mini-nav">
                    <li className="menu-with-image">
                        <Link 
                            to='/home' 
                            onClick={handleLinkClick}
                            style={{ color: 'black', display: 'block', width: '100%', height: '100%', padding: '10px 15px' }}
                        >
                            Home
                        </Link>
                    </li>
                    <li className="menu-with-image">
                        <Link 
                            to='/' 
                            onClick={handleLinkClick}
                            style={{ color: "black", display: 'block', width: '100%', height: '100%', padding: '10px 15px' }}
                        >
                            Store
                        </Link>
                    </li>
                    <li className="menu-with-image">
                        <Link 
                            to='/gallery' 
                            onClick={handleLinkClick}
                            style={{ color: "black", display: 'block', width: '100%', height: '100%', padding: '10px 15px' }}
                        >
                            Gallery
                        </Link>
                    </li>
                    <li className="menu-with-image">
                        <Link 
                            to='/workshop' 
                            onClick={handleLinkClick}
                            style={{ color: "black", display: 'block', width: '100%', height: '100%', padding: '10px 15px' }}
                        >
                            Workshop
                        </Link>
                    </li>
                    <li className="menu-with-image">
                        <Link 
                            to='/contact' 
                            onClick={handleLinkClick}
                            style={{ color: "black", display: 'block', width: '100%', height: '100%', padding: '10px 15px' }}
                        >
                            Contact
                        </Link>
                    </li>
                </ul>
            </Drawer>
        </>
    );
};

export default Mininav;